import React, { useEffect, useState } from "react";
import { useCore } from "./core";
import { useSession } from "./session";

const JudgingContext = React.createContext(null);

function JudgingProvider({eventId, children}) {
    const { runNoAuthAction } = useCore();
    const { tenant } = useSession();
    const [formsLoading, setFormsLoading] = useState(true);
    const [forms, setForms] = useState([]);
    const [codeSent, setCodeSent] = useState(false);
    const [isVerified, setIsVerified] = useState(false);
    const [message, setMessage] = useState('');
    const [judgesForm, setJudgesForm] = useState(0); 

    useEffect(() => {
        if (tenant) {
            loadForms();
        }
    }, [tenant])

    const loadForms = () => {
        setFormsLoading(true);
        runNoAuthAction('get_judging_forms', {tenantId: tenant.id, eventId}, response => {
            setForms(response.forms);
            setFormsLoading(false);
        });
    }

    const verifyJudge = (data) => {
        runNoAuthAction('verify_judge', {tenantId: tenant.id, eventId, ...data}, response => {
            setCodeSent(response.codeSent);
            setIsVerified(response.isValid);
            setMessage(response.message);
            setJudgesForm(response.formId);
        });
    }

    const submitJudgingForm = (data, callback) => {
        runNoAuthAction('submit_judging_form', {tenantId: tenant.id, eventId, ...data}, response => {
            callback(response);
        })
    }

    const provider = {
        formsLoading,
        forms,
        loadForms,
        verifyJudge,
        judgesForm,
        codeSent,
        isVerified,
        message,
        submitJudgingForm
    }

    return <JudgingContext.Provider value={provider}>{children}</JudgingContext.Provider>
}

function useJudging() {
    const context = React.useContext(JudgingContext);
    if (!context) {
        throw new Error('useJudging must be used within a JudgingProvider');
    }
    return context;
}

export { JudgingProvider, useJudging }